import React, { Component } from "react";
import CustomerDetailComponent from "../../components/Customers/CustomerDetailComponent";

class CustomerDetail extends Component {
  render() {
    return (
      <div>
        <CustomerDetailComponent />
      </div>
    );
  }
}

export default CustomerDetail;
